import { Component, input, inject, OnInit, DestroyRef } from "@angular/core";
import { FloatingContactPanelModel } from "./model/floating-contact-panel-model";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { map } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

const CONTACT_IMG_URL_DE = "portal-assets/img/kontakt.png";
const CONTACT_IMG_URL_EN = "portal-assets/img/kontakt_en.png";

type CurrentLanguage = "en" | "de";

@Component({
  selector: "portal-floating-contact-panel",
  templateUrl: "./floating-contact-panel.component.html",
  styleUrls: ["./floating-contact-panel.component.scss"],
  standalone: true,
  imports: [TranslatePipe, AsyncPipe],
})
export class FloatingContactPanelComponent implements OnInit {
  readonly #translateService = inject(TranslateService);
  readonly #destroyRef = inject(DestroyRef);
  model = input.required<FloatingContactPanelModel>();
  imgUrl = "";

  ngOnInit() {
    this.imgUrl = this.#getCurrentImgUrl(this.#translateService.currentLang as CurrentLanguage);
    this.#translateService.onLangChange
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        map((l) => this.#getCurrentImgUrl(l.lang as CurrentLanguage))
      )
      .subscribe((imgUrl) => {
        this.imgUrl = imgUrl;
      });
  }

  #getCurrentImgUrl(lang: CurrentLanguage) {
    return lang === "en" ? CONTACT_IMG_URL_EN : CONTACT_IMG_URL_DE;
  }
}
